import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/$companySlug/")({
  loader: () => {
    throw redirect({
      to: "/$companySlug/tenders",
      from: "/$companySlug",
    });
  },
});
